import * as React from "react";
import {colorBase} from "@Common/ui-components/heavy/common/design2/system-colors";

export const Ratio23Svg = ({}) => (
    <svg viewBox="0 0 100 100">
        <rect x={0} y={0} width={100} height={100} stroke="none" fill={colorBase}/>
        <rect x={20} y={0} width={100 - 20*2} height={100} stroke="none" fill="currentColor"/>
    </svg>
);

